/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import styled from 'styled-components';

export type CoopCancelReasonType =
  | 'reschedule'
  | 'notInterested'
  | 'other'
  | '';

type CoopCancelAppointmentComponentProps = {
  setCancelStatus: (reason: CoopCancelReasonType, details: string) => void;
  resetPageMode?: () => void;
};

type CoopCancelAppointmentComponentState = {
  reason: CoopCancelReasonType;
  details?: string;
};

class CoopCancelAppointmentComponent extends React.Component<
  CoopCancelAppointmentComponentProps,
  CoopCancelAppointmentComponentState
> {
  constructor(props: CoopCancelAppointmentComponentProps) {
    super(props);

    this.state = {
      reason: '',
      details: '',
    };
  }

  onReasonChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const reason: CoopCancelReasonType = e.target.value as CoopCancelReasonType;

    let details;
    switch (reason) {
      case 'reschedule':
        details = 'Will reschedule appointment';
        break;
      case 'notInterested':
        details = 'Client no longer interested';
        break;
      default:
        break;
    }

    this.setState({ reason, details });
  };

  onOtherReasonDetailsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const details = e.target.value;

    this.setState({ details });
  };

  render() {
    const { setCancelStatus, resetPageMode } = this.props;
    const { reason, details } = this.state;

    return (
      <>
        <h5>Are you sure you want to cancel this showing?</h5>

        <select
          required
          className="form-control"
          value={reason}
          onChange={this.onReasonChange}
          data-cy="select-reason"
        >
          <option value="" disabled hidden>
            - SELECT REASON -
          </option>
          <option value="reschedule">I Will Reschedule</option>
          <option value="notInterested">Client is No Longer Interested</option>
          <option value="other">Other (Custom)</option>
        </select>

        {reason === 'other' && (
          <textarea
            className="form-control"
            placeholder="Why are you cancel this showing?"
            onChange={this.onOtherReasonDetailsChange}
            value={details}
            data-cy="textarea-custom-reason"
          ></textarea>
        )}
        <br />
        <button
          className="btn btn-danger"
          disabled={!details}
          onClick={() => setCancelStatus(reason, details)}
          style={{ flex: 1, maxWidth: '160px' }}
          data-cy="send-cancellation"
        >
          Cancel Showing
        </button>
        {Boolean(resetPageMode) && (
          <StyledResetPage
            className="btn btn-default"
            onClick={() => resetPageMode()}
            data-cy="reset-page-mode"
          >
            Back
          </StyledResetPage>
        )}
      </>
    );
  }
}

export default CoopCancelAppointmentComponent;

const StyledResetPage = styled.button`
  flex: 1;
  margin-left: 16px !important;
`;
